module.exports = "../images/provide-fishing.jpg?v=10afe28";